module.exports = __webpack_public_path__ + "static/img/banner1.922a0a2.jpg";


//////////////////
// WEBPACK FOOTER
// ./assets/images/banner1.jpg
// module id = shm+
// module chunks = 12